import client from 'api/graphQL/config'
import {gql} from '@apollo/client'
import {BulkEditConfigurationInput, DatabaseEnableUpdateInput, FeatureFlagUpdateInput, DeleteCustomConfigOverrideTagInput} from 'graphql-api'

export const databaseEnableUpdate = (input: DatabaseEnableUpdateInput) =>
  client.mutate({
    mutation: gql`
      mutation databaseEnableUpdate($input: DatabaseEnableUpdateInput!) {
        databaseEnableUpdate (input: $input) {
          database {
            databaseId
            active
            enabled
            appVersion
            databaseVersion
          }
        }
      }
    `,
    variables: {
      input
    },
  })

export const featureFlagUpdate = (input: FeatureFlagUpdateInput) =>
  client.mutate({
    mutation: gql`
      mutation featureFlagUpdate ($input: FeatureFlagUpdateInput!) {
        featureFlagUpdate(input: $input) {
          database {
            databaseId
          }
        }
      }
    `,
    variables: {
      input
    },
  })

  export const bulkEditConfiguration = (input: BulkEditConfigurationInput) =>
  client.mutate({
    mutation: gql`
      mutation bulkEditConfiguration ($input: BulkEditConfigurationInput!) {
        bulkEditConfiguration(input: $input) {
          requests {
            requestId
          }
        }
      }
    `,
    variables: {
      input
    },
  })

export const deleteCustomConfigOverrideTag = (input: DeleteCustomConfigOverrideTagInput) =>
  client.mutate({
    mutation: gql`
      mutation deleteCustomConfigOverrideTag ($input: DeleteCustomConfigOverrideTagInput!) {
        deleteCustomConfigOverrideTag(input: $input) {
            isDeleted
        }
      }
    `,
    variables: {
      input
    },
  })
